import builder from '../builder';
import View from '../../streamline-icons/bold/view.svg';

export default builder('IconViewBold', View);
